import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listScenarios,
  createScenario,
  updateScenario,
  deleteScenario,
} from "./api";

// useScenarios provides the saved-scenarios list + create/update/delete mutations.
export function useScenarios() {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: ["scenarios"] });

  const list = useQuery({
    queryKey: ["scenarios"],
    queryFn: listScenarios,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const create = useMutation({ mutationFn: createScenario, onSuccess: invalidate });
  const update = useMutation({ mutationFn: updateScenario, onSuccess: invalidate });
  const remove = useMutation({ mutationFn: deleteScenario, onSuccess: invalidate });

  return { list, create, update, remove };
}
